import React, { useState } from 'react';
import api from './api';
import './styles/index.css';

const GestionUsuarios = ({ onBack }) => {
  const [searchUsername, setSearchUsername] = useState('');
  const [userData, setUserData] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchUsername.trim()) return;

    setLoading(true);
    setError('');
    setSuccess('');
    setUserData(null);

    try {
      const user = await api.adminGetUser(searchUsername.trim());
      setUserData(user);
    } catch (err) {
      setError(err.message || 'Usuario no encontrado');
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!userData || !newPassword.trim()) return;

    if (newPassword.length < 4) {
      setError('La contraseña debe tener al menos 4 caracteres');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await api.adminChangePassword(userData._id, newPassword);
      setSuccess(`✅ Contraseña de "${userData.username}" actualizada correctamente`);
      setNewPassword('');
    } catch (err) {
      setError(err.message || 'Error al cambiar contraseña');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setSearchUsername('');
    setUserData(null);
    setNewPassword('');
    setError('');
    setSuccess('');
  };

  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header dashboard-header-pro">
        <div className="header-brand">
          <img src="/Logo26.png" alt="501 Dart League" className="dashboard-logo" />
          <div className="header-brand-text">
            <h1>Gestión de Usuarios</h1>
            <span className="header-brand-subtitle">Cambiar contraseñas</span>
          </div>
        </div>
        <button onClick={onBack} className="logout-button">
          ← Volver
        </button>
      </div>

      {/* Main Content */}
      <main className="admin-home-main">
        <section className="gestion-usuarios-section">
          {/* Búsqueda */}
          <div className="gestion-card">
            <h3>🔍 Buscar Usuario</h3>
            <form onSubmit={handleSearch} className="gestion-form">
              <div className="gestion-input-group">
                <input
                  type="text"
                  value={searchUsername}
                  onChange={(e) => setSearchUsername(e.target.value)}
                  placeholder="Escribe el username..."
                  className="gestion-input"
                  disabled={loading}
                />
                <button type="submit" className="gestion-btn-search" disabled={loading || !searchUsername.trim()}>
                  {loading ? '...' : 'Buscar'}
                </button>
              </div>
            </form>
          </div>

          {/* Mensajes */}
          {error && <div className="gestion-error">{error}</div>}
          {success && <div className="gestion-success">{success}</div>}

          {/* Datos del usuario */}
          {userData && (
            <div className="gestion-card gestion-user-card">
              <h3>👤 Datos del Usuario</h3>
              <div className="gestion-user-info">
                <div className="gestion-user-row">
                  <span className="gestion-label">Username:</span>
                  <span className="gestion-value gestion-username">{userData.username}</span>
                </div>
                <div className="gestion-user-row">
                  <span className="gestion-label">Nombre completo:</span>
                  <span className="gestion-value">{userData.nombre}</span>
                </div>
                <div className="gestion-user-row">
                  <span className="gestion-label">Tipo:</span>
                  <span className="gestion-value">{userData.tipoUsuario || 'jugador'}</span>
                </div>
                <div className="gestion-user-row">
                  <span className="gestion-label">Estado:</span>
                  <span className={`gestion-value ${userData.activo !== false ? 'gestion-activo' : 'gestion-inactivo'}`}>
                    {userData.activo !== false ? '✓ Activo' : '✗ Inactivo'}
                  </span>
                </div>
                <div className="gestion-user-row">
                  <span className="gestion-label">ID:</span>
                  <span className="gestion-value gestion-id">{userData._id}</span>
                </div>
              </div>

              {/* Estadísticas de partidas */}
              {userData.estadisticas && (
                <div className="gestion-stats-section">
                  <h4>📊 Estadísticas</h4>
                  <div className="gestion-stats-grid">
                    <div className="gestion-stat-item">
                      <span className="gestion-stat-value">{userData.estadisticas.totalPartidas}</span>
                      <span className="gestion-stat-label">Total partidas</span>
                    </div>
                    <div className="gestion-stat-item">
                      <span className="gestion-stat-value gestion-stat-success">{userData.estadisticas.partidasJugadas}</span>
                      <span className="gestion-stat-label">Jugadas</span>
                    </div>
                    <div className="gestion-stat-item">
                      <span className="gestion-stat-value gestion-stat-pending">{userData.estadisticas.partidasPendientes}</span>
                      <span className="gestion-stat-label">Pendientes</span>
                    </div>
                  </div>
                </div>
              )}

              {/* Ligas */}
              {userData.ligas && userData.ligas.length > 0 && (
                <div className="gestion-ligas-section">
                  <h4>🏆 Ligas ({userData.ligas.length})</h4>
                  <div className="gestion-ligas-list">
                    {userData.ligas.map(liga => (
                      <div key={liga._id} className="gestion-liga-item">
                        <span className="gestion-liga-nombre">{liga.nombre}</span>
                        <span className={`gestion-liga-estado gestion-estado-${liga.estado}`}>
                          {liga.estado}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Torneos */}
              {userData.torneos && userData.torneos.length > 0 && (
                <div className="gestion-torneos-section">
                  <h4>🎯 Torneos ({userData.torneos.length})</h4>
                  <div className="gestion-torneos-list">
                    {userData.torneos.map(torneo => (
                      <div key={torneo._id} className="gestion-torneo-item">
                        <span className="gestion-torneo-nombre">{torneo.nombre}</span>
                        <span className={`gestion-torneo-estado gestion-estado-${torneo.estado}`}>
                          {torneo.estado}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Sin ligas ni torneos */}
              {(!userData.ligas || userData.ligas.length === 0) && (!userData.torneos || userData.torneos.length === 0) && (
                <div className="gestion-no-competiciones">
                  <p>ℹ️ Este usuario no está inscrito en ninguna liga ni torneo actualmente.</p>
                </div>
              )}

              {/* Cambiar contraseña */}
              <div className="gestion-password-section">
                <h4>🔐 Cambiar Contraseña</h4>
                <form onSubmit={handleChangePassword} className="gestion-form">
                  <div className="gestion-input-group">
                    <input
                      type="text"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="Nueva contraseña (mín. 4 caracteres)"
                      className="gestion-input"
                      disabled={loading}
                    />
                    <button 
                      type="submit" 
                      className="gestion-btn-change" 
                      disabled={loading || !newPassword.trim() || newPassword.length < 4}
                    >
                      {loading ? '...' : 'Cambiar'}
                    </button>
                  </div>
                </form>
              </div>

              <button onClick={handleClear} className="gestion-btn-clear">
                Limpiar y buscar otro
              </button>
            </div>
          )}

          {/* Instrucciones */}
          <div className="gestion-tips">
            <p>💡 <strong>Consejo:</strong> Busca por el username exacto del jugador. El sistema no distingue mayúsculas/minúsculas.</p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default GestionUsuarios;
